<template>
  <div class="school-list-view">
    <div class="school-list-view-mobile">
      <v-layout row align-end justify-space-between>
        <v-flex class="show-all-schools-wrapper checkbox-wrappper xs5">
          <input
            name="show-all-schools"
            v-model="showAllSchools"
            id="show-all-schools"
            class="show-all-schools"
            type="checkbox"
          />
          <label for="show-all-schools" class="show-all-schools-label">{{ $t('Show All Schools')}}</label>
        </v-flex>
        <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" class="xs4 sm2">
          <v-select
            :value="{column: 'name', descending: false}"
            :items="sortOptions"
            @change="(value) => {changeSort(value.column, value.descending)}"
            :clearable="true"
            label="sort by"
          ></v-select>
        </v-flex>
      </v-layout>
      <!-- Mobile -->
      <template>
        <v-data-table
          ref="schoolMapTableMobile"
          v-show="isMobile"
          :items="schoolList"
          hide-actions
          :pagination.sync="pagination"
          class="school-list-table-card school-list-table-mobile"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">
              <v-layout row wrap class="school-list-row-content">
                <v-flex xs12>
                  <v-layout row class="row-name">
                    <v-flex xs6>
                      <router-link
                        @click.native="$gtag.event('Learn More List');scrollToTop();"
                        :to="{name: 'schoolpage', params: {province: props.item.province, level: props.item.level, id: props.item.id }}"
                        class="school-name label"
                      >
                        {{
                        props.item.name }}
                      </router-link>
                    </v-flex>
                    <v-flex xs6 class="text-xs-right field">
                      <v-btn
                        @click.prevent="showNotification = true;
                             province=props.item.province;
                             school_type=props.item.level;
                             school_name=props.item.name;
                             school_id=props.item.id;"
                        class="email-me"
                      ></v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row>
                    <v-flex xs6 class="label">{{ currentYear }} {{ $t("score_table_label") }}</v-flex>
                    <v-flex
                      xs6
                      :class="[
                  'text-xs-right',
                  'field',
                  props.item.score >= 0 && props.item.score < 4.1 ? 'score_color_1': '',
                  props.item.score >= 4.1 && props.item.score < 6 ? 'score_color_2': '',
                  props.item.score >= 6 && props.item.score < 7.6 ? 'score_color_3': '',
                  props.item.score >= 7.6 && props.item.score <= 10 ? 'score_color_4': '',
                  ]"
                    >{{ props.item.score !== 'n/a' ? (parseFloat(props.item.score) % 1 === 0 ? parseFloat(props.item.score).toFixed(0) : parseFloat(props.item.score).toFixed(1)) : 'n/a' }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row>
                    <v-flex xs6 class="label">{{ currentYear }} {{ $t("rank_table_label") }}</v-flex>
                    <v-flex xs6 class="text-xs-right field">{{ props.item.ranking }}/{{schoolTotal}}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row class="row-city">
                    <v-flex xs6 class="label">{{ $t('City') }}</v-flex>
                    <v-flex xs6 class="text-xs-right field">{{ props.item.city }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row>
                    <v-flex class="add-to-compare text-xs-left">
                      <a
                        href="#"
                        @click.stop.prevent="$gtag.event('Add to Compare List');addToCompare(props.item);"
                      >{{ $t('Add to compare') }}</a>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </template>
    </div>

    <!-- Desktop -->
    <div class="school-list-view-full">
      <v-data-table
        ref="schoolMapTable"
        v-show="!isMobile"
        :headers="headers"
        :items="schoolList"
        hide-actions
        class="school-list-card"
        :pagination.sync="pagination"
      >
        <template v-slot:headers="props">
          <tr>
            <template v-for="(header, key) in props.headers">
              <th
                v-if="header.sortable == false"
                :key="key"
                :class="[
              header.align === 'left' ? 'text-xs-left' : '',
              header.class ? header.class: ''
            ]"
              >
                <span v-html="$t(header.text)"></span>
                <v-tooltip top v-if="header.tooltip && toolTipByName(header.tooltip)">
                  <template v-slot:activator="{ on }">
                    <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                  </template>
                  <span v-html="toolTipByName(header.tooltip)"></span>
                </v-tooltip>
              </th>
              <th
                v-else
                :key="header.text"
                :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
              header.align === 'left' ? 'text-xs-left' : '',
              header.class ? header.class: ''
              ]"
                @click="changeSort(header.value)"
              >
                <span v-html="$t(header.text)"></span>
                <v-icon small>keyboard_arrow_down</v-icon>
                <v-tooltip top v-if="header.tooltip && toolTipByName(header.tooltip)">
                  <template v-slot:activator="{ on }">
                    <v-icon class="tooltip-icon" v-on="on">help</v-icon>
                  </template>
                  <span v-html="toolTipByName(header.tooltip)"></span>
                </v-tooltip>
              </th>
            </template>
          </tr>
        </template>
        <template v-slot:items="props">
          <td class="school-name text-xs-left">
            <router-link
              @click.native="$gtag.event('Learn More List');scrollToTop();"
              :to="{name: 'schoolpage', params: {province: props.item.province, level: props.item.level, id: props.item.id }}"
            >{{ props.item.name }}</router-link>
          </td>
          <td
            :class="[
            'school-rating',
            'text-xs-center',
            props.item.score >= 0 && props.item.score < 4.1 ? 'score_color_1': '',
            props.item.score >= 4.1 && props.item.score < 6 ? 'score_color_2': '',
            props.item.score >= 6 && props.item.score < 7.6 ? 'score_color_3': '',
            props.item.score >= 7.6 && props.item.score <= 10 ? 'score_color_4': '',
            ]"
          >{{ props.item.score !== 'n/a' ? (parseFloat(props.item.score) % 1 === 0 ? parseFloat(props.item.score).toFixed(0) : parseFloat(props.item.score).toFixed(1)) : 'n/a' }}</td>
          <td class="text-xs-center">{{ props.item.ranking }}/{{schoolTotal}}</td>
          <td>{{ props.item.city }}</td>
          <td class="school-compare text-xs-center">
            <v-flex class="checkbox-wrappper">
              <input
                :name="`compare-schools-${props.item.id}`"
                :checked="isSchoolInComparison(props.item)"
                :id="`compare-schools-${props.item.id}`"
                class="compare-schools"
                type="checkbox"
                :disabled="compareSchoolFull && !isSchoolInComparison(props.item)"
                @click="$gtag.event('Add to Compare List');conditionalAddToCompare(props.item)"
              />
              <label :for="`compare-schools-${props.item.id}`" class="compare-schools-label"></label>
            </v-flex>
          </td>
          <td class="text-xs-center">
            <v-btn
              @click.prevent="showNotification = true;
                   province=props.item.province;
                   school_type=props.item.level;
                   school_name=props.item.name;
                   school_id=props.item.id;"
              class="email-me"
            ></v-btn>
          </td>
        </template>
      </v-data-table>
    </div>
    <v-layout justify-center class="school-list-view-pag">
      <div v-if="pages > 0">
        <ul>
          <li class="skip_previous">
            <span v-if="pagination.page == 1">
              <v-icon>chevron_left</v-icon>
            </span>
            <a v-else @click.stop="paginationGoTo(1)">
              <v-icon>chevron_left</v-icon>
            </a>
          </li>
          <li class="previous">
            <a
              v-if="pagination.page > 1"
              @click="paginationGoTo(pagination.page - 1)"
            >{{ $t('PREV') }}</a>
            <span v-else>{{ $t('PREV') }}</span>
          </li>
          <li v-for="n in pageItems" :key="n" class="number">
            <span v-if="pagination.page == n">{{ n }}</span>
            <span v-else-if="n == '...'">{{ n }}</span>
            <a v-else @click.stop="paginationGoTo(n)">{{ n }}</a>
          </li>
          <li class="next">
            <a
              v-if="pagination.page < pages"
              @click="paginationGoTo(pagination.page + 1)"
            >{{ $t('NEXT') }}</a>
            <span v-else>{{ $t('NEXT') }}</span>
          </li>
          <li class="skip_next">
            <span v-if="pages == pagination.page">
              <v-icon>chevron_right</v-icon>
            </span>
            <a v-else @click.stop="paginationGoTo(pages)">
              <v-icon>chevron_right</v-icon>
            </a>
          </li>
        </ul>
      </div>
    </v-layout>
    <div hidden class="text-xs-center pt-2">
      <v-pagination
        ref="vPagination"
        :total-visible="total_visible"
        v-model="pagination.page"
        :length="pages"
      ></v-pagination>
    </div>
    <SchoolNotification
      :province="province"
      :schoolType="school_type"
      :schoolName="school_name"
      :schoolId="school_id"
      :showNotification="showNotification"
      @sendCloseDialog="showNotification = false"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import SchoolNotification from "@/components/SchoolMap/SchoolNotification";
import RepositoryFactory from "@/services/RepositoryFactory";

const SystemRepository = RepositoryFactory.get("system");
const StorageService = RepositoryFactory.get('storage');

export default {
  name: "SchoolListView",
  components: {
    SchoolNotification
  },
  data() {
    return {
      showNotification: false,
      province: false,
      school_type: false,
      school_id: 0,
      school_name: false,
      selected: [],
      total_visible: 4,
      showAllSchools: false,
      isMobile: false,
      pagination: {
        rowsPerPage: 5
      },
      pageItems: []
    };
  },
  computed: {
    ...mapState({
      schoolTotal() {
        return this.$store.state.initialSearchSchoolListFilteredCount;
      },
      pages(state) {
        let vm = this;
        if (typeof vm.$refs.vPagination == "object") {
          let items = vm.$refs.vPagination.items;
          if (items.length > 0) {
            let uniqueItems = items.filter(function(item, index) {
              return items.indexOf(item) >= index;
            });
            vm.pageItems = uniqueItems;
          }
        }
        this.pagination.totalItems = state.schoolsInMap.length;
        if (
          this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) {
          return 0;
        }

        return Math.ceil(
          this.pagination.totalItems / this.pagination.rowsPerPage
        );
      },
      compareSchoolTotal() {
        return this.$store.state.compareSchool.length;
      },
      schoolList() {
        this.pagination.page = 1;
        let schools;
        if (this.showAllSchools == true) {
          schools = this.$store.state.searchSchoolList;
          let level = this.$store.state.currentEducationLevel;
          schools = schools.filter(school => school.level === level);
          this.$store.commit("CURRENT_SCHOOLS_IN_MAP", schools);
        } else {
          return this.$store.state.schoolsInMap;
        }
        return schools;
      },
      currentYear() {
        let latestYear = StorageService.getItem('latestYear');
        latestYear = JSON.parse(latestYear);
        let provinces = this.$store.state.provinceList;
        let currentProvince = this.$store.state.currentMapProvince;
        let currentProvinceValue;

        for (let i = provinces.length -1; i >= 0; i--) {
          if (provinces[i].name === currentProvince) {
            currentProvinceValue = provinces[i].value;
          }
        }

        let currentLevel = this.$store.state.currentEducationLevel;
        let currentYear = '';
        if(latestYear && currentProvinceValue && currentLevel) {
          currentYear = latestYear[currentProvinceValue + '_' + currentLevel];
          let prevYear = currentYear - 1;
          currentYear = ' ' + prevYear + ' - ' + currentYear.slice(-2);
        }

        return currentYear;
      },
      headers() {
        return [
          {
            text: "School Name",
            align: "left",
            value: "name",
            class: "header-school-name"
          },
          {
            text: this.$t("score_table_label") + this.currentYear,
            value: "score",
            tooltip: this.$t("score")
          },
          {
            text: this.$t("rank_table_label") + this.currentYear,
            value: "ranking"
          },
          {
            text: "City",
            value: "city",
            align: "left"
          },
          {
            text: "Add to compare",
            value: null,
            sortable: false
          },
          {
            text: "Notify me",
            value: null,
            sortable: false,
            class: ["notify-me"],
            tooltip: this.$t("Notify me")
          }
        ];
      }
    }),
    compareSchool: {
      get: function() {
        return this.$store.state.compareSchool;
      },
      set: function(value) {
        this.$store.commit("SET_COMPARE_SCHOOL", value);
      }
    },
    compareSchoolFull() {
      return this.compareSchool.length > 5;
    },
    sortOptions: function () {
      return [
        {value: {column: 'name', descending: false}, text: this.$t('sort_name_asc')},
        {value: {column: 'name', descending: true}, text: this.$t('sort_name_desc')},
        {value: {column: 'score', descending: true}, text: this.$t('sort_score_asc')},
        {value: {column: 'score', descending: false}, text: this.$t('sort_score_desc')},
        {value: {column: 'ranking', descending: false}, text: this.$t('sort_rank_asc')},
        {value: {column: 'ranking', descending: true}, text: this.$t('sort_rank_desc')},
        {value: {column: 'city', descending: false}, text: this.$t('sort_city_asc')},
        {value: {column: 'city', descending: true}, text: this.$t('sort_city_desc')},
      ];
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    checkIsMobile() {
      this.isMobile = parseInt(document.documentElement.clientWidth) < 960;
    },
    paginationGoTo(value) {
      let vm = this;
      vm.pagination.page = value;
    },
    changeSort(column, descending) {
      if (typeof descending == 'undefined') {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = descending;
      }
    },
    toolTipByName(name) {
      if (name !== undefined) {
        let provinces = this.$store.state.provinceList;
        let currentProvince = this.$store.state.currentMapProvince;
        let currentProvinceValue = "";
        for (let i = provinces.length - 1; i >= 0; i--) {
          if (provinces[i].name === currentProvince) {
            currentProvinceValue = provinces[i].value;
          }
        }

        let educationLevel =
          this.singleSchool !== undefined
            ? this.singleSchool.level
            : this.$store.state.currentEducationLevel;
        let tooltip = SystemRepository.getTooltipByName(
          name,
          currentProvinceValue,
          educationLevel,
          localStorage.getItem("language")
        );
        return tooltip || null;
      } else {
        return null;
      }
    },
    conditionalAddToCompare(school) {
      let schools = this.$store.state.compareSchool;
      let schoolInArray = schools.filter(function(e) {
        return e.id === school.id;
      });

      if (schoolInArray.length > 0) {
        schools = schools.filter(function(e) {
          return e.id !== school.id;
        });
        this.$store.commit("SET_COMPARE_SCHOOL", schools);
      } else {
        this.addToCompare(school);
      }
    },
    addToCompare(school) {
      let schools = this.$store.state.compareSchool;
      if (
        (schools.filter(function(e) {
          return e.id === school.id;
        }).length == 0 ||
          schools.length == 0) &&
        schools.length < 6
      ) {
        schools.push(school);
        this.$store.commit("SET_COMPARE_SCHOOL", schools);
      }
    },
    isSchoolInComparison(school) {
      return this.compareSchool.indexOf(school) > -1;
    },
    toggleToMapView() {
      this.checkIsMobile();
      if (!this.isMobile) {
        this.$store.commit("SET_SWITCHER_MAP_LIST", "map");
      }
    }
  },

  mounted() {
    window.addEventListener("resize", this.checkIsMobile);
    window.addEventListener("resize", this.toggleToMapView);
    this.checkIsMobile();
    if (!this.isMobile) {
      this.total_visible = 7;
      this.pagination.rowsPerPage = 50;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkIsMobile);
    window.removeEventListener("resize", this.toggleToMapView);
  }
};
</script>
